import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-bold whitespace-nowrap leading-[1.4]",
  {
    variants: {
      variant: {
        success: "bg-success-soft text-success border border-success-border [&>i]:bg-success",
        warning: "bg-warning-soft text-warning border border-warning-border [&>i]:bg-warning",
        danger: "bg-danger-soft text-danger border border-danger-border [&>i]:bg-danger",
        info: "bg-info-soft text-info border border-info-border [&>i]:bg-info",
        pending: "bg-pending-soft text-pending border border-line [&>i]:bg-pending",
        neutral: "bg-disabled-soft text-disabled border border-line [&>i]:bg-disabled",
        accent: "bg-primary-soft text-primary border-primary/20",
      },
      size: {
        sm: "px-1.5 py-0 text-[10px]",
        md: "px-2 py-0.5 text-xs",
      },
    },
    defaultVariants: { variant: "neutral", size: "md" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  dot?: boolean;
}

function Badge({ className, variant, size, dot = true, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {dot && <i aria-hidden className="size-1.5 rounded-full" />}
      {children}
    </span>
  );
}

export { Badge, badgeVariants };